import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UserQualificationV2 } from '@wilson/interfaces';
import { UserQualificationV2TransformValidTillPipe } from '@wilson/qualification-v2/common';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DateFnsModule } from 'ngx-date-fns';
import { OnClickRendererParams } from './confirmed-by-user-renderer';

@Component({
  selector: 'wilson-qualifications-v2-acquired-on-date-renderer',
  template: `
    <div class="cursor-pointer" (click)="onClick($event)">
      {{
        cellValue.validTill
          ? (cellValue | userQualificationV2TransformValidTill)
          : '---'
      }}
    </div>
  `,
  imports: [DateFnsModule, UserQualificationV2TransformValidTillPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [UserQualificationV2TransformValidTillPipe],
})
export class ValidTillRendererComponent implements AgRendererComponent {
  public cellValue!: Pick<UserQualificationV2, 'validTill'>;
  params!: OnClickRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(
    params: ICellRendererParams,
  ): Pick<UserQualificationV2, 'validTill'> {
    return {
      validTill: params.value,
    };
  }

  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.params?.onClick) {
      this.params.onClick(event, this.params.data);
    }
  }
}
